import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e3a15b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-start" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "table table-bordered" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["href"]
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.table.title), 1),
    _createElementVNode("table", _hoisted_3, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.table.columns, (column, index) => {
            return (_openBlock(), _createElementBlock("th", {
              key: column.title,
              class: _normalizeClass({ 'text-end': _ctx.isNumber(column.format)})
            }, [
              _createElementVNode("a", {
                href: "#",
                class: _normalizeClass({ 'sort-up': _ctx.sortIndex == index && !_ctx.sortDown, 'sort-down': _ctx.sortIndex == index && _ctx.sortDown }),
                onClick: ($event: any) => (_ctx.sort(index))
              }, _toDisplayString(column.title), 11, _hoisted_4)
            ], 2))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedValues, (record, row) => {
          return (_openBlock(), _createElementBlock("tr", { key: row }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record, (value, col) => {
              return (_openBlock(), _createElementBlock("td", {
                key: col,
                class: _normalizeClass({ 'text-end': _ctx.isNumber(_ctx.table.columns[col].format)})
              }, [
                (_ctx.hasLink(col))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.makeLink(record, _ctx.table.columns[col].link),
                      class: "link-dark"
                    }, _toDisplayString(_ctx.format(value, _ctx.table.columns[col].format)), 9, _hoisted_5))
                  : _createCommentVNode("", true),
                (!_ctx.hasLink(col))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.format(value, _ctx.table.columns[col].format)), 1))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ]))
        }), 128))
      ])
    ])
  ]))
}